/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * Type of receipt to send
 */
export enum SendReceiptType {
  ETICKET = 'ETICKET',
  EMD = 'EMD',
  BOTH = 'BOTH'
}

